import React, {ChangeEvent, useEffect, useState} from "react";
import {Input} from "../../../ui-components/Input/Input";
import {ValidationErrorText} from "../../../ui-components/ValidationErrorText/ValidationErrorText";

interface AddressInputProps {
    address: string;
    onSetAddress: (address: string) => void;
    onSetIsAddressValid: (isAddressValid: boolean) => void;
}

export const AddressInput: React.FunctionComponent<AddressInputProps> = (props) => {
    const [errors, setErrors] = useState<string[]>([]);
    const [isValid, setIsValid] = useState<boolean>(true);
    const requiredAddressError = 'Address is a required field.';
    const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

    useEffect(() => {
        props.onSetIsAddressValid(isValid);
    }, [isValid])

    const onChange = (event: ChangeEvent) => {
        props.onSetAddress((event.target as HTMLInputElement).value);
        validateAddress();
    }

    const onKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
        validateAddress();
    }

    const validateAddress = () => {
        let errorsTemp: string[] = [];
        if (props.address === '') {
            errorsTemp.push(requiredAddressError);
        }
        setErrors(errorsTemp);
        setIsValid(errorsTemp.length === 0);
    }

    const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        setIsSubmitted(true);
        validateAddress();
    }

    return <div>
        <Input isValid={isValid} type='text' required={true} value={props.address} onChange={onChange}
               onKeyUp={onKeyUp} onBlur={onBlur}/>
        {isSubmitted && errors.map((error: string) => {
            return <ValidationErrorText key={error} text={error}/>
        })}
    </div>
}
